<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-09-29 17:01:11
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-10-26 23:56:44
 * @FilePath: /partner.chaoyongtuan.com/src/modules/auth/dyAuthSuccess.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
	<el-dialog title="团长授权" width="600px" show-close :visible.sync="visible">
		<div class="flex-column flex-just-center flex-align-center">
			<i class="el-icon-success yx-color-success success mb-22"></i>
			<p>账号授权成功，首次同步时间较长，请耐心等待。</p>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="visible = false" :disabled="isDisabled">{{ btnText }}</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	name: 'DyAuthSuccess',
	data() {
		return {
			visible: false,
			num: 3,
		};
	},
	methods: {
		show() {
			this.visible = true;
			this.setTimer();
		},
		setTimer() {
			clearTimeout(timer);
			let timer = setInterval(() => {
				if (this.num > 0) {
					this.num--;
				} else {
					this.num = '';
					clearTimeout(timer);
				}
			}, 1000);
		},
	},
	computed: {
		btnText() {
			return `关闭 ${this.seconds}`;
		},
		seconds() {
			return this.num ? `(${this.num}s)` : '';
		},
		isDisabled() {
			return this.num ? true : false;
		},
	},
};
</script>
<style lang="less" scoped>
.success {
	font-size: 80px;
}
</style>
